/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../constants';
import { baseButton, baseLink } from '../styles/base.styles';
import { spinnerTransitions } from '../styles/spinner.styles';

export const SPINNER_CLASSNAME_PREFIX = 'ribbons-outline-button';

const { fonts, responsiveText } = theme;

export const outlineButtonStyle = css`
  border-radius: ${pxToRem(6)};
  border: solid 1px ${palette.deepPurpleBase};
  background-color: transparent;

  .${BUTTON__CONTENT_CLASS} {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    height: ${pxToRem(28)};
    ${responsiveText.BODY.MD}
  }

  &:hover {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);
    border: solid ${pxToRem(1)} color-mix(in srgb, ${palette.deepPurpleBase} 20%, white);

    .${BUTTON__CONTENT_CLASS} {
      color: ${palette.deepPurpleBase};
    }
  }

  &.focus-visible:focus {
    background-color: var(--neutral-white-base);
  }

  ${spinnerTransitions(SPINNER_CLASSNAME_PREFIX)}
`;

export const loadingSpinner = css`
  margin-top: ${pxToRem(-2)};
`;

export const outlineButton = css`
  ${baseButton}
  ${outlineButtonStyle}

  &:disabled {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);
    border: 1px solid color-mix(in srgb, ${palette.deepPurpleBase} 50%, white);
    cursor: not-allowed;
    .${BUTTON__CONTENT_CLASS} {
      color: ${palette.deepPurpleBase};
    }
  }
`;

export const outlineButtonLink = css`
  ${baseLink}
  ${outlineButtonStyle}
`;
